import { CRUCIBLE_DEFAULTS, MM_FACTORS, calculateCrucible, formatCapacity, crucibleSummary } from './crucible-capacity-core.js';
function initialize(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const field = key => root.querySelector(`[data-crucible-field="${key}"]`);
  const node = key => root.querySelector(`[data-crucible-${key}]`);
  let state = { ...CRUCIBLE_DEFAULTS };
  let result = null;
  for (const key of Object.keys(state)) { if (field(key).type === 'checkbox') field(key).checked = state[key]; else field(key).value = state[key]; }
  function update() {
    for (const key of Object.keys(state)) state[key] = field(key).type === 'checkbox' ? field(key).checked : field(key).value;
    node('cylinder').hidden = state.shape !== 'cylinder';
    node('frustum').hidden = state.shape !== 'frustum';
    field('freeboard').disabled = !state.freeboardEnabled;
    node('error').textContent = ''; node('results').hidden = true; node('empty').hidden = false;
    node('copy-fallback').hidden = true; result = null;
    try {
      result = calculateCrucible(state);
      node('full').textContent = `${formatCapacity(result.fullMl)} mL = ${formatCapacity(result.fullMl)} cm³`;
      node('fill').textContent = `${formatCapacity(result.fillMl)} mL`;
      node('unfilled').textContent = `${formatCapacity(result.emptyMl)} mL`;
      node('dimensions').textContent = `${state.shape === 'cylinder' ? `Internal diameter ${state.diameter}` : `Internal top diameter ${state.topDiameter}, bottom diameter ${state.bottomDiameter}`} ${state.unit}; internal height ${state.height} ${state.unit}; ${state.freeboardEnabled ? `your freeboard ${state.freeboard} ${state.unit}` : 'no freeboard applied (0 height)'}. Geometric fill height ${formatCapacity(result.fillHeightMm)} mm.`;
      node('results').hidden = false; node('empty').hidden = true;
    } catch (error) { node('error').textContent = error.message; }
    node('copy').disabled = !result;
  }
  root.addEventListener('input', event => {
    if (event.target === field('unit') && event.target.value !== state.unit) {
      for (const key of ['diameter', 'topDiameter', 'bottomDiameter', 'height', 'freeboard']) if (field(key).value !== '' && Number.isFinite(Number(field(key).value))) field(key).value = String(Number(field(key).value) * MM_FACTORS[state.unit] / MM_FACTORS[event.target.value]);
    }
    update();
  });
  node('copy').addEventListener('click', async () => {
    if (!result) return;
    const summary = crucibleSummary(result);
    try { await navigator.clipboard.writeText(summary); node('status').textContent = 'Geometry summary copied. Paste it into your inquiry and provide the actual requirements separately.'; }
    catch { node('copy-fallback').hidden = false; node('copy-text').value = summary; node('copy-text').focus(); node('status').textContent = 'Select and copy the geometry summary below.'; }
  });
  update();
}
document.querySelectorAll('[data-crucible-calculator]').forEach(initialize);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-crucible-calculator]').forEach(initialize));
